<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="configAuto" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>
        <el-tabs v-if="showTable" class="mt10" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="分类" name="cat" v-if="showCatTable"></el-tab-pane>
            <el-tab-pane label="分类品牌" name="catBrand" v-if="showCatBrandTable"></el-tab-pane>
            <el-tab-pane label="分类品牌型号" name="catBrandModelSpec" v-if="showCatBrandModelTable"></el-tab-pane>
            <el-tab-pane label="分类品牌型号规格" v-if="showCatBrandModelFixedSpecTable" name="all"></el-tab-pane>
            <el-tab-pane label="自采" v-if="showCentBuyFlag && !centBuyMode" name="singleCentBuy"></el-tab-pane>
            <el-tab-pane label="集采" v-if="showCentBuyFlag && centBuyMode" name="focusCentBuy"></el-tab-pane>
        </el-tabs>
        <swb-result-table class="mt10" name="result_table" ref="result_table" :confKey="confKey" :configAuto="configAuto" :custConfEnabled="custConfEnabled" :onConfigReady="onConfigReady" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    //
    import devcReqrApi from '../../api/devcReqr'
    //
    export default{
        name: 'swb-adopted-device-list-select',
        avlScopes: 'retailer',
        desc: '采购入选服务列表',
        props: {
            checkIds: {
                type: Array,
                default: null
            },
            skuFlag: {
                type: Boolean,
                default: null,
            },
            centBuyMode: {
                type: Boolean,
                default: null,
            },
            showTable: {
                type: Boolean,
                default: false,
            },
            showCatTable: {
                type: Boolean,
                default: false,
            },
            showCatBrandTable: {
                type: Boolean,
                default: false,
            },
            showCatBrandModelTable: {
                type: Boolean,
                default: false,
            },
            showCatBrandModelFixedSpecTable: {
                type: Boolean,
                default: false,
            },
            filter: {
                type: Object,
                default: function () {

                },
            },
            catId: {
                type: Number,
                default: null
            },
            brandId: {
                type: Number,
                default: null
            },
            fixedSpec: {
                type: String,
                default: null
            },
            model: {
                type: String,
                default: null
            },
            checkBox: {
                type: Boolean,
                default: true
            },
            showAccFlag: {
                type: Boolean,
                default: true
            },
            showCentBuyFlag: {
                type: Boolean,
                default: true
            },
            //
            nxtActiveName: {
                type: String,
                default: null
            },
            lowCostFlag: { // 选择耗材信息
                type: Boolean,
                default: null
            },
            notAssetDefFlag: { // 选择耗材信息
                type: Boolean,
                default: false
            },
            showAssetDefFlag: { // 选择耗材信息
                type: Boolean,
                default: false
            },
            contractEnded: { // 合同是否已结束
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                confKey: "swb-adopted-device-list-select",
                configAuto: true,
                custConfEnabled: true,
                theTableHeight: 500,
                queryOnLoad: true,
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 250,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                comRoleList: [],
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,

                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                activeName: 'cat'
            }
        },
        watch: {
            nxtActiveName: function (newValue, oldValue) {
                if(newValue == 'first') {
                    this.getAdoptedDeviceList();
                }
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            if(!Utils.isTrue(this.checkBox)) {
                this.multiSelect = false;
                this.multiPageSelect = false;
                this.rowNoShow = true;
            }
            this.getActionName();
        },

        mounted() {
            //
            this.initResultTable();
            this.handleInitChecked();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {

            getActionName: function () {
                let activeName = null;
                if(this.showCatTable) {
                    activeName = "cat";
                } else if(this.showCatBrandTable) {
                    activeName = "catBrand";
                } else if(this.showCatBrandModelTable) {
                    activeName = "catBrandModelSpec";
                } else if(this.showCatBrandModelFixedSpecTable) {
                    activeName = "all";
                } else if(!Utils.isNoB(this.showCentBuyFlag) && this.showCentBuyFlag) {
                    activeName = "singleCentBuy";
                } else if(!Utils.isNoB(this.showCentBuyFlag) && !this.showCentBuyFlag) {
                    activeName = "focusCentBuy";
                }
                this.activeName = activeName;
            },
            handleInitChecked() {
                let initChecked = this.checkIds;
                let resultTable = this.$refs.result_table;
                resultTable.setInitChecked(initChecked, true);
            },
            onQueryConfigReady: function () {
                if(Utils.isFalse(this.centBuyMode) || Utils.isTrue(this.showCentBuyFlag)) {
                    this.updateQueryModelHiddenField("centBuyMode", true);
                }
                if(Utils.isTrue(this.showAccFlag)) {
                    this.updateQueryModelHiddenField("asmblAccFlag", true);
                }
                if(Utils.isTrue(this.notAssetDefFlag)) {
                    this.updateQueryModelFilter("searchAssetDefFlag", false)
                }
            },
            updateQueryModelHiddenField: function (itemCode, hiddenValue) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {hidden: hiddenValue};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelFilter: function (itemCode, value) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {value: value};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'favorLevel': function (row, colName, colValue, rowIndex) {
                        return row.favorLevel == 1 ? '一级' : (row.favorLevel == 2 ? '二级' : (row.favorLevel == 3 ? '三级' : (row.favorLevel == 4 ? '四级' : (row.favorLevel == 5 ? '五级' : ''))));
                    },
                    'price': function (row, colName, colValue, rowIndex) {
                        return row.price != null ? (row.price).toFixed(2) : ''
                    },
                    'centBuyMode': function (row, colName, colValue, rowIndex) {
                        return row.centBuyMode ? '集采' : '自采';
                    },
                    'assetDefId': function (row, colName, colValue, rowIndex) {
                        let domHtml = "";
                        if(row.assetDefId == -1) {
                            domHtml = domHtml + '<span>未关联</span>';
                        } else {
                            domHtml = domHtml + '<span>已关联</span>';
                        }
                        return domHtml;
                    },
                    'assetAccFlag': function (row, colName, colValue, rowIndex) {
                        let domHtml = "";
                        if(row.assetDefId != -1) {
                            if(row.asmblAccFlag) {
                                domHtml = domHtml + '<span>组装件</span>';
                            } else {
                                if(row.assetType == 2) {
                                    domHtml = domHtml + '<span>耗材</span>';
                                } else {
                                    domHtml = domHtml + '<span>资产</span>';
                                }
                            }
                        }

                        return domHtml;
                    },

                }, /* 单元格按钮点击处理函数 */{});
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getAdoptedDeviceList();
            },
            handleClick(tab, event) {
                this.activeName = tab.name;
                this.pageNoChangeHandler(1, this.pageSize);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getAdoptedDeviceList();
            },
            getAdoptedDeviceList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                filterItems = Object.assign(filterItems, self.filter);
                //
                if(!Utils.isNoB(self.centBuyMode)) {
                    filterItems.centBuyMode = self.centBuyMode;
                }
                if(self.activeName == 'cat') {
                    filterItems.goodsCatId = self.filter.catId;
                } else if(self.activeName == 'catBrand') {
                    filterItems.goodsCatId = self.filter.catId;
                    filterItems.goodsBrandId = self.filter.brandId;
                } else if(self.activeName == 'catBrandModelSpec') {
                    filterItems.goodsCatId = self.filter.catId;
                    filterItems.goodsBrandId = self.filter.brandId;
                    filterItems.model = self.filter.goodsModel;
                } else if(self.activeName == 'all') {
                    filterItems.goodsCatId = self.filter.catId;
                    filterItems.goodsBrandId = self.filter.brandId;
                    filterItems.model = self.filter.goodsModel;
                    filterItems.fixedSpec = self.filter.goodsFixedSpec;
                } else if(self.activeName == 'singleCentBuy') {
                    filterItems.centBuyMode = false;
                } else if(self.activeName == 'focusCentBuy') {
                    filterItems.centBuyMode = true;
                }
                let notAssetDefFlag = self.notAssetDefFlag;
                if(Utils.isTrue(notAssetDefFlag)) {
                    filterItems.searchAssetDefFlag = false;
                    // self.notAssetDefFlag = false;
                }
                if(Utils.isNoB(filterItems.disabled)) {
                    filterItems.disabled = false;
                }
                if(Utils.isTrue(self.showAssetDefFlag)) {
                    filterItems.searchAssetDefFlag = false;
                }
                if(!Utils.isNoB(self.contractEnded)) {
                    filterItems.contractEnded = self.contractEnded;
                }
                filterItems.lowCostFlag = self.lowCostFlag;
                filterItems.skuFlag = self.skuFlag;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                devcReqrApi.getAdoptedDevicePagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        self.renderTable(result.data.rows, pagination)
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                let selectList = this.getTableSelection();
                if(selectList.length <= 0) {
                    result.type = "warn";
                    result.message = "请选择商品信息";
                } else {
                    result.data = selectList;
                    result.type = "info";
                }

                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/GoodsInSelect.vue